import { getHeaders, SubmissionURL } from './config';
import { checkStatus } from './normalizer';
import { LumenProgramYear } from '../types/carrier.types';
import { throwIfDateOverlap } from '../helpers/dateOverlapError';

export async function getCurrentProgramYearsData(): Promise<LumenProgramYear[]> {
    const url = `${SubmissionURL}/lumen-program-year/active`;
    const options = {
        method: 'GET',
        headers: getHeaders(),
    };
    return fetch(url, options)
        .then(checkStatus)
        .then((resp) => resp.json());
}

export async function getAllProgramYearsData(productLineType?: string): Promise<LumenProgramYear[]> {
    const url = `${SubmissionURL}/lumen-program-year${productLineType ? '?productLineType=' + productLineType : ''}`;
    const options = {
        method: 'GET',
        headers: getHeaders(),
    };
    return fetch(url, options)
        .then(checkStatus)
        .then((resp) => resp.json());
}

export async function createLumenProgramYear(data: Partial<LumenProgramYear>): Promise<LumenProgramYear> {
    const resp = await fetch(`${SubmissionURL}/lumen-program-year`, {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify(data),
    });
    await throwIfDateOverlap(resp);
    return Promise.resolve(resp)
        .then(checkStatus)
        .then((r: Response) => r.json());
}

export async function updateLumenProgramYear(id: string, data: Partial<LumenProgramYear>): Promise<LumenProgramYear> {
    const resp = await fetch(`${SubmissionURL}/lumen-program-year/${id}`, {
        method: 'PATCH',
        headers: getHeaders(),
        body: JSON.stringify(data),
    });
    await throwIfDateOverlap(resp);
    return Promise.resolve(resp)
        .then(checkStatus)
        .then((r: Response) => r.json());
}

export async function deleteLumenProgramYear(id: string): Promise<void> {
    return fetch(`${SubmissionURL}/lumen-program-year/${id}`, {
        method: 'DELETE',
        headers: getHeaders(),
    })
        .then(checkStatus)
        .then(() => undefined);
}
